/** Whole-screen states: a first load in flight, or one that failed. */
import type { ApiFailure } from "../api/client";
import { LoadError } from "./LoadError";
import { SkeletonRows } from "./Skeleton";

export function LoadingPage({ rows = 4 }: { rows?: number }) {
  return (
    <main className="state-page">
      <span className="skeleton state-page__title" />
      <SkeletonRows rows={rows} />
    </main>
  );
}

export function FailedPage({ failure, onRetry }: { failure: ApiFailure; onRetry: () => void }) {
  return (
    <main className="state-page">
      <LoadError failure={failure} onRetry={onRetry} />
    </main>
  );
}

/** Worth a Try again: never arrived, or the service failed. A 4xx is an answer, not a blip. */
export function transient(f: ApiFailure): boolean {
  return f.status === 0 || f.status >= 500;
}
